import React from "react";
import { capitalize } from "../../utils/textFunctions";

const PatientName = ({ data, summary: isSummary }) => {
  if (isSummary && data.length === 0) {
    return <div>Name: [Empty]</div>;
  }

  if (isSummary) {
    const { family, given } = data[0];
    const sourceCode = data[0].extension
      ? data[0].extension.filter(e => e.url.includes("sourceCode"))
      : "";
    return (
      <div>
        Name: {family ? family : ""}, {given ? given.join(", ") : ""}{" "}
        {sourceCode[0] ? "[" + sourceCode[0].valueString + "]" : ""}
      </div>
    );
  }

  if (!isSummary && data.length === 0) {
    return (
      <section>
        <h3>Names</h3>
        <div>
          <h4>Empty</h4>
        </div>
      </section>
    );
  }

  return (
    <section>
      <h3>Names</h3>
      <div>
        <div>
          <h4>Family Name</h4>
        </div>
        <div>
          <h4>Given Name</h4>
        </div>
        <div>
          <h4>Use</h4>
        </div>
      </div>

      {data.map((name, index) => {
        return (
          <div key={index}>
            <div>
              <div>{name.family ? name.family : "-"}</div>
            </div>
            <div>
              {name.given
                ? name.given.map((givenName, gnKey) => {
                    return <div key={gnKey}>{givenName}</div>;
                  })
                : "-"}
            </div>
            <div>
              <div>{capitalize(name.use)}</div>
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default PatientName;
